var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1072.03 189.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: url(#linear-gradient);\n        stroke-miterlimit: 10;\n        stroke-width: 2.99px;\n      }\n\n      .cls-2 {\n        fill: #1c1c1c;\n      }\n\n      .cls-3 {\n        fill: #fcfcfc;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 700.47,
    y1: 94.65,
    x2: 1072.03,
    y2: 94.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4fdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bbf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#89f1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5fecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#3ce8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#22e5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0fe3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#03e2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00e2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#00ff80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ff9d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00ffbf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,26.96h43.9v119.94h76.72v38.47H0V26.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m140.31,26.96h44.13v158.41h-44.13V26.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m207.98,106.62v-.45c0-46.17,36.21-82.38,85.32-82.38,27.84,0,47.52,8.6,64.27,23.08l-25.8,31c-11.32-9.5-22.63-14.94-38.25-14.94-22.86,0-40.51,19.24-40.51,43.45v.45c0,25.57,17.88,43.9,43,43.9,10.64,0,18.78-2.26,25.35-6.56v-19.24h-31.23v-32.14h72.87v71.29c-16.75,13.8-40.06,24.44-68.8,24.44-49.33,0-86.22-33.95-86.22-81.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m387.44,26.96h43.9v59.29h56.35V26.96h43.9v158.41h-43.9v-60.2h-56.35v60.2h-43.9V26.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m598.35,65.43h-47.52V26.96h138.95v38.47h-47.52v119.94h-43.9v-119.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m765.37,93.03L703.17,0h60.3l33.53,53.27L830.81,0h58.95l-62.2,92.49,64.9,96.81h-60.3l-36.24-57.06-36.51,57.06h-58.95l64.9-96.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m897.88,0h89.51c28.94,0,48.95,7.57,61.66,20.55,11.09,10.82,16.77,25.42,16.77,44.08v.54c0,28.94-15.41,48.14-38.94,58.14l45.16,65.98h-60.58l-38.13-57.33h-22.99v57.33h-52.46V0Zm87.08,90.86c17.85,0,28.12-8.65,28.12-22.45v-.54c0-14.87-10.82-22.45-28.39-22.45h-34.34v45.43h34.61Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m765.37,93.03L703.17,0h60.3l33.53,53.27L830.81,0h58.95l-62.2,92.49,64.9,96.81h-60.3l-36.24-57.06-36.51,57.06h-58.95l64.9-96.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m897.88,0h89.51c28.94,0,48.95,7.57,61.66,20.55,11.09,10.82,16.77,25.42,16.77,44.08v.54c0,28.94-15.41,48.14-38.94,58.14l45.16,65.98h-60.58l-38.13-57.33h-22.99v57.33h-52.46V0Zm87.08,90.86c17.85,0,28.12-8.65,28.12-22.45v-.54c0-14.87-10.82-22.45-28.39-22.45h-34.34v45.43h34.61Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a2cd5ee16423cb3c93d1b605fb12855e.svg";
export { ForwardRef as ReactComponent };